import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

export const fetchKgsConfig = async () => {
  const response = await apiService.makeRequest('/api/kgs1/')
  if (!response.kgs) throw new Error('Invalid response format: kgs config not found')
  return { ...response.kgs, promo: response.promo || null }
}

export const fetchKgsPackages = async () => {
  const response = await apiService.makeRequest('/api/topup/')
  if (!Array.isArray(response.topup)) throw new Error('Invalid response format: topup array not found')
  return response.topup.filter((pkg) => pkg.kgs1 !== undefined)
}

const createKgsPayment = async (body) => {
  const amount = Object.values(body)[0]
  if (!Number.isSafeInteger(amount) || amount <= 0) throw new Error('INVALID_AMOUNT')
  try {
    const response = await apiService.makeRequest('/api/kgs1/', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    if (response?.error) throw new Error(response.error)
    if (!response?.link) throw new Error('Invalid response format: link not found')
    return { link: response.link }
  } catch (error) {
    if (error.message === 'error sum') throw new Error('INVALID_AMOUNT')
    if (error.message === 'error limit') throw new Error('LIMIT_ORDER')
    if (error.message === 'error backend') throw new Error(error.status === 400 ? 'INVALID_REQUEST' : 'BACKEND_ERROR')
    throw error
  }
}

export const createPaymentByKgs = (kgs) => createKgsPayment({ kgs })
export const createPaymentByCrystals = (crystals) => createKgsPayment({ crystal: crystals })
export const openKgsPayment = (link, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(link, onRedirect, 'KGS', paymentWindow)
}

export default {
  fetchKgsConfig,
  fetchKgsPackages,
  createPaymentByKgs,
  createPaymentByCrystals,
  openKgsPayment
}
